import {
	createAiReviewJob,
	getAiReviewJob,
	getAiReviewJobs,
	getReviewRequestsForAi,
} from '@/services/community/contents/reviews/aiReviewJobs'

export default {
	namespaced: true,
	state: {
		jobList: { data: [], meta: { total: 0 } },
		jobStatus: 'init',
		jobDetail: null,
		jobDetailStatus: 'init',
		jobActionStatus: 'init',
		reviewRequestOptions: [],
	},
	getters: {
		getJobList: state => state.jobList,
		getJobStatus: state => state.jobStatus,
		getJobDetail: state => state.jobDetail,
		getJobDetailStatus: state => state.jobDetailStatus,
		getJobActionStatus: state => state.jobActionStatus,
		getReviewRequestOptions: state => state.reviewRequestOptions,
	},
	mutations: {
		SET_JOB_LIST(state, val) {
			state.jobList = val
		},
		SET_JOB_STATUS(state, val) {
			state.jobStatus = val
		},
		SET_JOB_DETAIL(state, val) {
			state.jobDetail = val
		},
		SET_JOB_DETAIL_STATUS(state, val) {
			state.jobDetailStatus = val
		},
		SET_JOB_ACTION_STATUS(state, val) {
			state.jobActionStatus = val
		},
		SET_REVIEW_REQUEST_OPTIONS(state, val) {
			state.reviewRequestOptions = val
		},
	},
	actions: {
		async dispatchAiReviewJob({ commit }, payload) {
			commit('SET_JOB_ACTION_STATUS', 'pending')
			try {
				const { data } = await createAiReviewJob(payload)
				commit('SET_JOB_ACTION_STATUS', 'success')
				return data
			} catch (error) {
				commit('SET_JOB_ACTION_STATUS', 'error')
				throw error
			}
		},
		async fetchAiReviewJobs({ commit }, params) {
			commit('SET_JOB_STATUS', 'pending')
			try {
				const { data } = await getAiReviewJobs(params)
				commit('SET_JOB_LIST', data)
				commit('SET_JOB_STATUS', 'success')
				return data
			} catch (error) {
				commit('SET_JOB_STATUS', 'error')
				throw error
			}
		},
		async fetchAiReviewJob({ commit }, uuid) {
			commit('SET_JOB_DETAIL_STATUS', 'pending')
			try {
				const { data } = await getAiReviewJob(uuid)
				commit('SET_JOB_DETAIL', data.data || data)
				commit('SET_JOB_DETAIL_STATUS', 'success')
				return data
			} catch (error) {
				commit('SET_JOB_DETAIL_STATUS', 'error')
				throw error
			}
		},
		async fetchReviewRequestsForAi({ commit }, params) {
			try {
				const { data } = await getReviewRequestsForAi(params)
				commit('SET_REVIEW_REQUEST_OPTIONS', data.data || data)
				return data
			} catch (error) {
				commit('SET_REVIEW_REQUEST_OPTIONS', [])
				throw error
			}
		},
	},
}
